<template>
  <div class="SessionControl">
    <h2>順番表</h2>

    <div
      style="height:500px; width:100%; overflow-y:auto; background-color:#808080; text-align:left; padding:10px; border-radius: 3px;"
    >
      <draggable
        :options="{group:'group', animation: 150}"
        v-model="entryOrder"
        element="ul"
        @end="draggableEnd()"
        class="pl-0"
      >
        <li
          v-for="(item,index) in entryOrder"
          :key="item.entrynumber"
          style="list-style: none; background-color:#FFFFFF; text-align:left; padding:10px; margin:5px 30px; border-radius: 3px;"
        >
          <B>No.{{index+1}} [{{item.playtimes}}回Play]</B>
          {{item.parts}}.{{item.name}} {{item.entune}}
          {{item.player1}} {{item.player2}} {{item.player3}} {{item.player4}} {{item.player5}} {{item.player6}} {{item.player7}} {{item.player8}} {{item.player9}}
          <div>
            <base-button size="sm" @click="changeStage(index,item.stage)">{{item.stage}}</base-button>
            <base-button size="sm" @click="finishSess(index,item)">{{item.sessionStatus}}</base-button>
            <base-button size="sm" @click="fixSessOrder(index,item)">{{item.fixedOrder}}</base-button>
            <base-button size="sm" v-b-modal="sessOrderModalId(item.entrynumber)">JOIN</base-button>
            <base-button size="sm" @click="deleteSess(index,item)">削除</base-button>

            <!-- Modal Component -->
            <b-modal
              @ok="sendJoin(item.entrynumber)"
              :id="'sessOrderModal' + item.entrynumber "
              title="このセッションにジョイン"
            >
              <p class="my-4">{{item.entune}}{{item.parts}}.{{item.name}}{{item.stage}}</p>

              <multiselect
                v-model="selected"
                deselect-label="一人を選んでください。"
                track-by="artistuid"
                label="name"
                placeholder="誰の代理？"
                :options="loginUserList"
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
              ></multiselect>

              <multiselect
                v-model="selectedParts"
                deselect-label="パートを選んでください。"
                placeholder="パートを選ぶ。"
                :options="parts"
                :searchable="true"
                :show-labels="false"
              ></multiselect>
            </b-modal>
          </div>
        </li>
      </draggable>
    </div>
    <div style="height:10px;"></div>
    <router-link to="/toMonitor">リスト、チャット表示</router-link>
    <div style="height:10px;"></div>
    <div style="height:10px;"></div>
    <router-link to="/iinest">いいネスト表示</router-link>
    <div style="height:10px;"></div>

    <h2>代理エントリー</h2>
    <div style="background-color: lightgray;">
      <multiselect
        v-model="selectedEntry"
        deselect-label="一人を選んでください。"
        track-by="uid"
        label="name"
        placeholder="誰の代理？"
        :options="loginUserList"
        :custom-label="customLabel"
        :searchable="true"
        :allow-empty="false"
        :show-labels="false"
      ></multiselect>
      <div style="height:10px;"></div>

      <multiselect
        v-model="selectedStage"
        deselect-label="ステージを選んでください。"
        placeholder="ステージを選ぶ。"
        :options="stage"
        :searchable="true"
        :allow-empty="false"
        :show-labels="false"
      ></multiselect>
      <div style="height:10px;"></div>
      <multiselect
        v-model="selectedPartsEntry"
        deselect-label="パートを選んでください。"
        placeholder="パートを選ぶ。"
        :options="parts"
        :searchable="true"
        :allow-empty="false"
        :show-labels="false"
      ></multiselect>
      <div style="height:10px;"></div>
      <multiselect
        v-model="selectedTunes"
        deselect-label="曲を選んでください。"
        placeholder="曲を選ぶ。"
        :options="trackList"
        :searchable="true"
        track-by="trackId"
        label="Title"
        :allow-empty="false"
        :show-labels="false"
      ></multiselect>
      <div style="height:10px;"></div>
      <multiselect
        v-model="selectedKeys"
        deselect-label="キーを選んでください"
        placeholder="キーを選ぶ。"
        :options="keys"
        :searchable="true"
        :allow-empty="false"
        :show-labels="false"
      ></multiselect>

      <div>
        <base-button @click="newEntry">代理NEW ENTRY</base-button>
      </div>
    </div>
    <div style="height:50px;"></div>
    <h2>YOUTUBEライブ配信</h2>

    <base-input v-model="videoId" type="text" placeholder="videoId"></base-input>
    <div>
      <base-button @click="sendvideoId">sendvideoId</base-button>
    </div>
    <div style="height:50px;"></div>

    <h2>イベント作成</h2>

    <base-input type="text" placeholder="イベントタイトル" v-model="eventTitle"></base-input>

    <DatePickers v-on:date="datepick" />
    <base-input type="text" placeholder="場所" v-model="eventPlace"></base-input>

    <base-input type="text" placeholder="スタート時間" v-model="eventStartTime"></base-input>

    <b-textarea placeholder="詳細" v-model="eventDetail"></b-textarea>
    <div v-html="compiledMarkdown"></div>

    <base-button @click="eventSet()">送信</base-button>
    <div style="height:20px;"></div>

    <!-- <base-button @click="trackinn()">trakc</base-button>-->

    <h2>楽曲登録</h2>

    <base-input type="text" placeholder="タイトル/アーティスト名" v-model="trackTitle"></base-input>
    <base-input type="text" placeholder="タイトルアルファベット" v-model="titleSlug"></base-input>
    <base-input type="text" placeholder="歌詞URL" v-model="lyricUrl"></base-input>
    <base-input type="text" placeholder="YOUTUBE" v-model="trackYoutube"></base-input>
    <base-input type="text" placeholder="リードシート" v-model="leadsheet"></base-input>

    <base-button @click="trackSet()">送信</base-button>
    <div style="height:20px;"></div>
    <liveImageJPJ />
    <base-button style="text-align: left;" @click="sendReset">全ポイントリセット</base-button>
       <div
      style="height:500px; width:100%; overflow-y:auto; background-color:#808080; text-align:left; padding:10px; border-radius: 3px;"
    >
     
    </div>
  </div>
   <!--   var eo1 = [];
    var newLine1 = [];
    var ttrr = [];
    var ttrr2 = [];

    var event = "";

    Object.keys(this.jpj.eventList).forEach((val, key) => {
      var tt = this.jpj.eventList[val].fromiineList;
      event = this.jpj.eventList[val].eventTitle;
      console.log(event);
      Object.keys(tt).forEach((val, key) => {
        const ttt = tt[val];
        var eo = [];

        Object.keys(ttt).forEach((val, key) => {
          if (ttt[val].iine) {
            eo.push(this.jpj.loginuser[val].uid);
          }
        });
        var json = {
          event: event,
          uid: this.jpj.loginuser[val].uid,
          iine: eo.length
        };
        eo1.push(json);
      });
    });
    Object.keys(this.jpj.loginuser).forEach((val, key) => {
      newLine1 = eo1.filter(function(item, index) {
        if (item.uid == val) return true;
      });
      Object.keys(newLine1).forEach((val, key) => {
        ttrr.push(newLine1[val]);
      });
    });

    ttrr.sort(function(a, b) {
      if (a.iine > b.iine) return -1;
      if (a.iine < b.iine) return 1;
      return 0;
    });

    var tetet = {};

    this.newLine = ttrr; -->
</template>


<script>
import firebase from "firebase";
import Multiselect from "vue-multiselect";
import draggable from "vuedraggable";
import Datepicker from "vuejs-datepicker";
import DatePickers from "./components/JavascriptComponents/DatePickers";
import liveImageJPJ from "./components/liveImageJPJ";
import jpj from "../jpopjam0813.json";

export default {
  name: "SessionControl",
  components: { Multiselect, draggable, Datepicker, DatePickers, liveImageJPJ },

  data() {
    return {
      trackTitle: "",
      lyricUrl: "",
      leadsheet: "",
      trackYoutube: "",
      today: "2018-10-04",
      DatePickerFormat: "yyyy-MM-dd",
      list: [],
      eventTitle: "",
      modalShow: false,
      eventDetail: "",
      eventDate: "",
      eventPlace: "",
      eventStartTime: "",
      mslist: "",
      eboard: "",
      entrylist: [],
      videoId: "https://www.youtube.com/watch?v=XOzGU9hQptU",
      finlist: [],
      finnumber: 0,
      selectedSession: [],
      selectedplSession: [],
      selectedplSession2: [],
      selectedplSession3: [],
      selectedPersonpr: [],
      selectedfinSession: [],
      selectedParts: null,
      selectedPartsEntry: null,
      entune: "",
      plyor: [],
      result: "",
      selectedsess: "",
      selectedPerson: [],
      loginUserList: [],
      en1: "",
      nowplaynumber: "",
      artistname: "",
      notbr: "",
      isButtonDisabled: false,
      show: true,
      toOrder: [],
      finname: "",
      image: "",
      sortedbanndlist: [],
      sortedacolist: [],
      toplist: [],
      point: "",
      iine: "",
      playt: "",
      clist: [],
      flist: [],
      nlist: [],
      forSelectlist: [],
      slist: [],
      entryOrder: [], // 最新状態はここにコピーされる
      name: "", // 名前
      board: "",
      selected: null,
      selectedEntry: null,
      selectedStage: null,
      selectedKeys: null,
      stageselecter: "Band",
      stage: ["お任せ(推奨)", "Band", "Aco"],
      parts: ["Vo", "Gt", "Ba", "Dr", "Kb", "Per", "cho", "Ins"],
      keys: [
        "原キー",
        "+6",
        "+5",
        "+4",
        "+3",
        "+2",
        "+1",
        "-1",
        "-2",
        "-3",
        "-4",
        "-5",
        "-6"
      ],
      trackList: [],
      namelist: [],
      entrystatus: [],
      selectedTunes: "",
      newName: "",
      isAllSelected: false,
      selectedTrackId: [],
      entrynumber: 0,
      titleSlug: "",
      jpj: jpj,
      newLine: [],
      tetet: [
        { uid: "OYJ5fLPZsthIaogmS3fzRY1EEWZ2", iine: "31" },
        { uid: "Wj0mEP6KXGOzm5nzg0KsfpNCTEg1", iine: "31" },
        { uid: "2JUYKgESHYcujGlwzO8mV5uZwHl1", iine: "16" },
        { uid: "8J99aarTaRPHXjUOj9iK2aBGv3X2", iine: "26" },
        { uid: "bSlXtsQr4caUYikbVj5q92IdEww2", iine: "22" },
        { uid: "AzSogdBVWTUX4zr8pHwsfMyU3Ud2", iine: "19" },
        { uid: "XtJCwSu4FHRJt8pEekrfKDNDpvZ2", iine: "21" },
        { uid: "pRhx81ObwOQTuMtGbHH5cgrmfmi1", iine: "15" },
        { uid: "8oZXFzi3ZbMkWYvgI08ZH5ph7BH2", iine: "14" },
        { uid: "WUuZHHCdZDTijBWxbbdLi5wlS7N2", iine: "26" },
        { uid: "XYtD3j7pwGPNwtw2Ny12ceIlZvr1", iine: "17" },
        { uid: "7VaeLpobNZaFRKRFEQLvV9WUPmY2", iine: "24" },
        { uid: "BFStNIsBr5aMbB0ILDzU86GvmhG2", iine: "24" },
        { uid: "Fh15d2u977R0bIoQpb0ZNiXQ4Cm1", iine: "15" },
        { uid: "lvDqMdlDsgXiFkljtxX4XZk0TbK2", iine: "13" },
        { uid: "vh23QnnG9Thr8n8RaNIjWv6KyBr1", iine: "13" },
        { uid: "8JLVyBC81FPOuMq6Ct1KhcmqvKE2", iine: "12" },
        { uid: "QfDJzjIgbAayQIL5gkooTlfgz433", iine: "20" },
        { uid: "SJIusxdDnSOjdFeDXBl4PQFHUCL2", iine: "12" },
        { uid: "TtReFkqOQpaCCFkKS5f12T65AYk2", iine: "12" },
        { uid: "U1RLn3Qa1WZmDuAMXztksSmCgQr1", iine: "12" },
        { uid: "icoDSKivNTYQKrsECSYZIkhuKPG2", iine: "13" },
        { uid: "je3Vm8a4CeVhQQqRiULxne2f1Er2", iine: "19" },
        { uid: "w1cu3XH5Dia9CtakMy3ly46oOk23", iine: "15" },
        { uid: "3TFYfK34TuZwgfmrUUwBs8K0L542", iine: "19" },
        { uid: "6c2oHtchWJPXuRh3XoCdVnmhvr42", iine: "11" },
        { uid: "G2vpoHB6TAT0ZhccW9gdE5nvlA32", iine: "11" },
        { uid: "MFoUdf4BL6Xpp8iDnfe5Gc3xRpT2", iine: "20" },
        { uid: "O9J8rQNIPNRtxnV0N20RUc2y8V43", iine: "11" },
        { uid: "ZWvpvepg7NYhZI5aRbm292ReWgj2", iine: "11" },
        { uid: "f4EgIE8fcDfFELXoQptMjQR9YEh1", iine: "19" },
        { uid: "ghiz2fcwN8VrSPsrXRLXXF32G1H2", iine: "22" },
        { uid: "jp2L32RYqTeCRN2J02TF4zGilUz1", iine: "26" },
        { uid: "jtE08gA9KxPshChBXFsw6NNOahR2", iine: "21" },
        { uid: "zgiApFJKFTPUjujS8lDwtRu9sEh1", iine: "11" },
        { uid: "1gigqUuB7FQ2L5TGWetMPRqoxM62", iine: "12" },
        { uid: "25QkXgnWZeOwbEvHur0BNFp6PqI2", iine: "14" },
        { uid: "6K8bvuO7wDWTGQFZWDP1xvtQ7np1", iine: "10" },
        { uid: "G5KcuI4VMWexkFwaZsT0hFrNN0f2", iine: "21" },
        { uid: "GzLKCv6t9bfPpL4wgB3lQep5E4F2", iine: "10" },
        { uid: "MQamFjeOQxQb7c0gfRZAodhDfSR2", iine: "20" },
        { uid: "RIC3DRViwXaOqc8e0zhqLvArWkM2", iine: "10" },
        { uid: "ZQsyT1STlpQw9quwAxvuAJQ1GI32", iine: "12" },
        { uid: "B5XPSofjBcZHpAiyCU1KVfBWd2a2", iine: "9" },
        { uid: "Bk8H0nh2W9gy5vl5AcZv6Ej5jsX2", iine: "18" },
        { uid: "IfmXHKK2ZETSbYBEIiYbZSDuPI53", iine: "15" },
        { uid: "Qfi8sA6GwfcFfZXC7eX44cexSuG3", iine: "9" },
        { uid: "uYnu442WOjhhuVugfzBiWVyTg472", iine: "9" },
        { uid: "2AM8Iey4JzVpHoyXc7jPmG6bvSK2", iine: "8" },
        { uid: "Lr5gih8XqfgWTiNamCP7ZCnhVZS2", iine: "8" },
        { uid: "PbzOpwVzZAgdVIduMlQ1mkIKYJq1", iine: "8" },
        { uid: "Z1tMznPm9uYgtcfgGSijC49B4Eu2", iine: "8" },
        { uid: "aPwVJXSoOzatkErlHTdYddSkF8G3", iine: "10" },
        { uid: "ebhnc48D2XY25Hhsf38rtHfWAu42", iine: "8" },
        { uid: "giLwNsM7OxgsOLLSqTrJeYpPWOY2", iine: "14" },
        { uid: "nEny44olzpQhA2OU41XRpl53MZB3", iine: "8" },
        { uid: "qs99l6XQg3cQEUGT0gxFeUF5gT92", iine: "8" },
        { uid: "t2xkI2CwWZZZeQEDs09HjXovL0v2", iine: "16" },
        { uid: "xQBM49gteSTou6nkvupKUcgjTvD2", iine: "11" },
        { uid: "bgJsM7MDfoXTSpzIWSB3dTSVRyP2", iine: "7" },
        { uid: "iS9hGv9WUmciURziYTHpYAeWuc02", iine: "7" },
        { uid: "lEmuBc7RlqVD1OVoWUYZ52LVtFc2", iine: "7" },
        { uid: "mgt7Fw0tLnPKWXi4clbR1dVz2q83", iine: "7" },
        { uid: "Ic6Q211iApMfTaLkNsimlSAogCi2", iine: "6" },
        { uid: "fxZ1ftCwpwSyc3vdWf5GgESvuy03", iine: "6" },
        { uid: "r2TAoJo5jhY5yHZZv1EAfgn6vOM2", iine: "10" },
        { uid: "u2i532X5d3Nol4vZpgYb1dAkrrI2", iine: "4" },
        { uid: "6lJjZzPuX5P47phSSai6WscLVOD3", iine: "3" },
        { uid: "HfArQpXoWSUwjCoNddpLDhtZqZi2", iine: "3" },
        { uid: "MSEqKfjrh7hBgoxfJruMizZO4Wn2", iine: "3" },
        { uid: "eGK9bEQBgVSyy0U3ue7ue9xwpfE2", iine: "3" },
        { uid: "kZSoBavBIBaO2XyqHUjqeNUMrJ83", iine: "3" },
        { uid: "s0NyebCjfbX7pVP3jHKPiJ0JwzI2", iine: "3" },
        { uid: "vJpgTxbYflRSvSqlq2h2Q1EWdj12", iine: "3" },
        { uid: "6JMyXkK32aO2MJtI2JtsOtTnkeg1", iine: "3" },
        { uid: "BwRbpaz2DePBqutwFTwvmB5aAry2", iine: "2" },
        { uid: "EzpmGaXWFVPL4bu3unE7aKonQi33", iine: "2" },
        { uid: "ZTTQR9CctrWoFIji8NsHfHwMH0C3", iine: "2" },
        { uid: "1gWkoHHWLRVTWKdjCJ201i5rDFr1", iine: "1" },
        { uid: "kbmExi00KGTtz9OvKA4A9VDX2Aw1", iine: "1" },
        { uid: "l6ZrbDqKWWbkI7xU56b37vejBov1", iine: "1" },
        { uid: "00YKRM8OiGQhUDEEK29fzRwyIXB2", iine: "0" },
        { uid: "01uQoZCh0OgU8F429E1oNlDHS133", iine: "0" },
        { uid: "DnoGqL8NUWPm1LXwVFQUiHlBxec2", iine: "0" },
        { uid: "M55d5JK8xDTRl97rDhavMFbLiyQ2", iine: "0" },
        { uid: "oyoUOyb44Ofd14ziTymxs7fZrLl2", iine: "0" }
      ]
    };
  },
  computed: {
    nowJoinSessionInfo() {
      return this.$store.state.nowJoinSessionInfo;
    },
    compiledMarkdown: function() {
      const MarkdownIt = require("markdown-it");
      const meta = require("markdown-it-meta");
      const md = new MarkdownIt();
      md.use(meta);
      const result = md.render(this.eventDetail);

      return result;
    }
  },
  created() {
    var db = firebase.firestore();
    var cityRef = db.collection("cities")
    var setWithMerge = cityRef.add(
      {
        capital: true,
        aaa: 5
      },    );



    firebase
      .database()
      .ref("loginuser/")
      .on("value", snapshot => {
        var rootList = snapshot.val();
        let eo = [];
        Object.keys(rootList).forEach((val, key) => {
          eo.push(rootList[val]);
        });
      });

    firebase.auth().onAuthStateChanged(user => {
      if (user.uid == "MQamFjeOQxQb7c0gfRZAodhDfSR2") {
        var dt = new Date();
        var year = dt.getFullYear();
        var month = dt.getMonth() + 1;
        var date = dt.getDate();
        this.today = year + "-" + month + "-" + date;

        this.listen();
      } else {
        this.$router.push("/top");
      }
    });
  },

  methods: {
    customLabel({ name, uid }) {
      return `${name} – ${uid}`;
    },
    datepick(date) {
      this.eventDate = date;
    },
    listenuid(item) {
      return this.jpj.loginuser[item];
    },
    listen() {
      var useruid = firebase.auth().currentUser.uid;
      firebase
        .database()
        .ref("loginuser/" + useruid)
        .on("value", snapshot => {
          var loginuser = snapshot.val();
          this.name = loginuser.name;
          this.image = loginuser.image;
        });

      firebase
        .database()
        .ref("eventList/" + this.nowJoinSessionInfo + "/entryOrder/")
        .on("value", snapshot => {
          if (snapshot.val()) {
            const rootList = snapshot.val();
            let eo = [];
            Object.keys(rootList).forEach((val, key) => {
              eo.push(rootList[val]);
            });
            this.entryOrder = eo;
            this.entrynumber = eo.length;
          }
        });

      firebase
        .database()
        .ref("trackList/")
        .on("value", snapshot => {
          if (snapshot.val()) {
            const rootList = snapshot.val();
            let list3 = [];

            Object.keys(rootList).forEach((val, key) => {
              list3.push(rootList[val]);
            });
            this.trackList = list3;
          }
        });

      firebase
        .database()
        .ref("loginuser/")
        .on("value", snapshot => {
          if (snapshot.val()) {
            const rootList = snapshot.val();
            let list = [];

            Object.keys(rootList).forEach((val, key) => {
              list.push(rootList[val]);
            });

            var nlist = list.filter(function(element) {
              return element.status !== "";
            });

            this.loginUserList = nlist;
          }
        });
    },

    selectAllTracks() {
      if (this.isAllSelected) {
        this.selectedTrackId = [];
        this.isAllSelected = false;
      } else {
        this.selectedTrackId = [];
        for (var item in this.trackList) {
          this.selectedTrackId.push(this.trackList[item].trackId);
        }
        this.isAllSelected = true;
      }
    },
    select() {
      if (this.selectedTrackId.length !== this.trackList.length) {
        this.isAllSelected = false;
      } else {
        this.isAllSelected = true;
      }
    },

    draggableEnd() {
      firebase
        .database()
        .ref("eventList/" + this.nowJoinSessionInfo + "/entryOrder/")
        .set(this.entryOrder);
    },

    deleteSess(index, item) {
      if (
        window.confirm(
          item.name +
            "の" +
            item.entune +
            "を削除しますか？※最後の一つは消せません。"
        )
      ) {
        firebase
          .database()
          .ref("loginuser/" + item.artistuid)
          .update({ status: "not_entry" });

        firebase
          .database()
          .ref("eventList/" + this.nowJoinSessionInfo + "/entryOrder/" + index)
          .remove();
        this.draggableEnd();
      }
    },

    fixSessOrder(index, item) {
      if (
        window.confirm(item.name + "の" + item.entune + "を順番確定しますか？")
      ) {
        firebase
          .database()
          .ref("loginuser/" + item.artistuid + "/message")
          .push({
            image: this.image,
            name: this.nowJoinSessionInfo,
            message: "セッションの順番が確定しました。"
          });

        firebase
          .database()
          .ref("eventList/" + this.nowJoinSessionInfo + "/entryOrder/" + index)
          .update({ fixedOrder: "確定済" });
      }
    },

    sessOrderModalId(index) {
      return "sessOrderModal" + index;
    },

    finishSess(index, item) {
      var times = 0;
      firebase
        .database()
        .ref("loginuser/" + item.artistuid + "/played")
        .once("value", snapshot => {
          times = snapshot.val();
        });

      if (item.sessionStatus == "finished") {
        firebase
          .database()
          .ref("eventList/" + this.nowJoinSessionInfo + "/entryOrder/" + index)
          .update({ sessionStatus: "coming" });

        firebase
          .database()
          .ref("loginuser/" + item.artistuid)
          .update({ played: times - 1, status: "now_entry" });
      } else {
        firebase
          .database()
          .ref("eventList/" + this.nowJoinSessionInfo + "/entryOrder/" + index)
          .update({ sessionStatus: "finished" });

        firebase
          .database()
          .ref("loginuser/" + item.artistuid)
          .update({ played: times + 1, status: "not_entry" });
      }
    },

    changeStage(index, stage) {
      if (stage == "Band") {
        firebase
          .database()
          .ref("eventList/" + this.nowJoinSessionInfo + "/entryOrder/" + index)
          .update({ stage: "Aco" });
      } else {
        firebase
          .database()
          .ref("eventList/" + this.nowJoinSessionInfo + "/entryOrder/" + index)
          .update({ stage: "Band" });
      }
    },

    eventSet() {
      if (
        confirm(
          "この内容で登録しますか？\n\n" +
            this.eventTitle +
            "\n" +
            this.eventDetail +
            "\n" +
            this.eventDate +
            "\n" +
            this.eventPlace +
            "\n" +
            this.eventStartTime +
            "\n" +
            this.selectedTrackId
        )
      ) {
        var myRef = firebase
          .database()
          .ref("eventList/")
          .push();
        var key = myRef.getKey();

        var newData = {
          eventId: key,
          eventTitle: this.eventTitle,
          eventDetail: this.eventDetail,
          eventPlace: this.eventPlace,
          eventStartTime: this.eventStartTime,
          eventDate: this.eventDate,
          selectedTrackId: this.selectedTrackId,
          eventStatus: "coming"
        };

        myRef.set(newData);
      }
    },

    trackSet() {
      if (
        confirm(
          "この内容で登録しますか？\n\n" +
            this.trackTitle +
            "\n" +
            this.lyricUrl +
            "\n" +
            this.leadsheet +
            "\n" +
            this.trackYoutube
        )
      ) {
        var myRef = firebase
          .database()
          .ref("trackList/")
          .push();
        var key = myRef.getKey();
        var tt = this.trackTitle.split("/");

        var newData = {
          trackId: key,
          Title: this.trackTitle,
          trackTitle: tt[0],
          trackArtist: tt[1],
          lyricUrl: this.lyricUrl,
          trackYoutube: this.trackYoutube,
          titleSlug: this.titleSlug,
          leadSheet: this.leadsheet
        };

        myRef.set(newData);
      }
    },

    sendvideoId() {
      var videoId = this.videoId;
      var result = videoId.replace("https://www.youtube.com/watch?v=", "");
      firebase
        .database()
        .ref("eventList/" + this.nowJoinSessionInfo + "/videoId/")
        .set({
          ID: result
        });
    },

    newEntry() {
      var useruid = this.selectedEntry["uid"];
      var artistname = this.selectedEntry["name"];
      var played = 0;
      var playtimes = played;
      var image = "";
      var pr = "";

      firebase
        .database()
        .ref("loginuser/" + useruid + "/played")
        .once("value", snapshot => {
          played = snapshot.val();
        });

      firebase
        .database()
        .ref("loginuser/" + useruid + "/image")
        .once("value", snapshot => {
          image = snapshot.val();
        });

      firebase
        .database()
        .ref("loginuser/" + useruid + "/name")
        .on("value", snapshot => {
          artistname = snapshot.val();
        });

      firebase
        .database()
        .ref("loginuser/" + useruid + "/pr")
        .on("value", snapshot => {
          pr = snapshot.val();
        });

      if (this.selectedStage == "お任せ(推奨)") {
        var selectedStage = this.stageselecter;
      } else {
        var selectedStage = this.selectedStage;
      }

      var selectedKeys = this.selectedKeys;
      var selectedTunes = this.selectedTunes.Title;
      var selectedPartsEntry = this.selectedPartsEntry;

      if (
        useruid == null ||
        selectedStage == null ||
        selectedTunes == null ||
        selectedPartsEntry == null ||
        selectedKeys == null
      ) {
        this.isButtonDisabled = false;

        alert("全てを選択してください");
      } else {
        if (
          confirm(
            "この内容でエントリーしますか？\n\n" +
              artistname +
              "\n" +
              selectedStage +
              "ステージ\n" +
              selectedTunes +
              " key" +
              selectedKeys +
              "\nパート " +
              selectedPartsEntry +
              "\n ※ 一度エントリーすると基本変更はできません！\nどうしても変更の場合はスタッフまで。"
          )
        ) {
          var myRef = firebase
            .database()
            .ref("eventList/" + this.nowJoinSessionInfo + "/entryOrder/")
            .push();
          var key = myRef.getKey();

          var newData = {
            playtimes: played,
            entrynumber: key,
            stage: selectedStage,
            entune: selectedTunes + "." + selectedKeys,
            image: image,
            parts: selectedPartsEntry,
            artistuid: useruid,
            name: artistname,
            sessionStatus: "coming",
            pr: pr,
            fixedOrder: "未確定"
          };

          firebase
            .database()
            .ref(
              "eventList/" +
                this.nowJoinSessionInfo +
                "/entryOrder/" +
                this.entrynumber
            )
            .set(newData);

          firebase
            .database()
            .ref("eventList/" + this.nowJoinSessionInfo + "/messageBoard/")
            .push({
              image: image,
              name: artistname,
              message:
                selectedPartsEntry + ">" + selectedTunes + "をエントリー！"
            });

          firebase
            .database()
            .ref("loginuser/" + useruid)
            .update({
              status:
                selectedTunes +
                " " +
                selectedKeys +
                "を" +
                selectedPartsEntry +
                "でエントリー中"
            });

          alert("順番が確定するまでお待ちください！楽しんで！");
        }
      }
    },

    sendJoin(index) {
      var useruid = this.selected["uid"];
      var artistname = this.selected["name"];
      var selectedParts = this.selectedParts;

      var selper = 0;
      var selectedsessionId = 0;

      firebase
        .database()
        .ref("eventList/" + this.nowJoinSessionInfo + "/entryOrder/")
        .orderByChild("entrynumber")
        .startAt(index)
        .endAt(index)
        .once("value", snapshot => {
          selectedsessionId = Object.keys(snapshot.val());
        });

      firebase
        .database()
        .ref(
          "eventList/" +
            this.nowJoinSessionInfo +
            "/entryOrder/" +
            selectedsessionId
        )
        .on("value", snapshot => {
          if (snapshot.val()) {
            const rootList = snapshot.val();
            let list = [];

            Object.keys(rootList).forEach((val, key) => {
              var result = val.match(/player./);

              if (result != null) {
                list.push(rootList[val]);
              }
            });

            selper = list.length;
          }
        });
      var selp = selper + 1;
      var selplayernumbername = "player" + selp;
      var selplayernumberuid = "p_uid" + selp;
      if (artistname == null || selectedParts == null) {
        this.isButtonDisabled = false;

        alert("すべてを選択してください");
      } else {
        if (
          confirm(
            "この内容でジョインしますか？\n" + artistname + "\n" + selectedParts
          )
        ) {
          firebase
            .database()
            .ref(
              "eventList/" +
                this.nowJoinSessionInfo +
                "/entryOrder/" +
                selectedsessionId
            )
            .update({
              [selplayernumbername]: selectedParts + "." + artistname,
              [selplayernumberuid]: useruid
            });
          this.modalShow = false;
          this.selected = null;
          this.selectedParts = null;
        }
      }
    },

    sendReset() {
      if (confirm("本当にポイント、プレイ回数をリセットしますか？")) {
        firebase
          .database()
          .ref("loginuser/")
          .on("value", snapshot => {
            if (snapshot.val()) {
              const rootList = snapshot.val();
              let list = [];

              Object.keys(rootList).forEach((val, key) => {
                setTimeout(function() {
                  firebase
                    .database()
                    .ref("loginuser/" + val)
                    .update({
                      played: 0
                    });
                }, 1000);
              });
            }
          });
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.item-image img {
  border-radius: 50%;
  vertical-align: top;
}
</style>